import React, { createContext, useState, useEffect } from 'react'
import { useQuery } from "@apollo/client/react";
import { GET_REALEFLOW_LOGIN_TOKEN } from '@/housefolios-components/PropertySearch/queries'

export const PropertySearchContext = createContext({
  propertySearchOptions: ['Leads'],
})

export const PropertySearchProvider = ({ children, session  }) => {
  const [propertySearchOptions, setPropertySearchOptions] = useState([
    'Leads',
  ])

  const memberNorm = String(session?.me?.activeOrg?.member || '').toLowerCase()
  const isSpecialMember = ['pep', 'pacemorby', 'astroflip'].includes(
    memberNorm,
  )
  const isPropertySearchRetired = [
    'pep',
    'pacemorby',
    'astroflip',
  ].includes(memberNorm)
  const isCreativeMLSMember = ['pacemorby', 'astroflip'].includes(
    memberNorm,
  )
  const { data } = useQuery(GET_REALEFLOW_LOGIN_TOKEN, {
    skip: !isSpecialMember || isPropertySearchRetired,
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'network-only',
  })

  useEffect(() => {
    if (data?.getRealeflowLoginToken) {
      const accountDetails =
        data.getRealeflowLoginToken.AccountDetails || {}
      const options = ['Leads']
      if (accountDetails.HasCommercialLeads) {
        options.push('Commercial Leads')
      }
      if (accountDetails.HasResidentialInvestorLeads) {
        options.push('Find Fix & Flippers')
      }
      if (isCreativeMLSMember) {
        options.push('Creative MLS')
      }
      setPropertySearchOptions(options)
    } else if (isCreativeMLSMember) {
      const options = ['Leads']
      options.push('Creative MLS')
      setPropertySearchOptions(options)
    }
  }, [data, isCreativeMLSMember])

  return (
    <PropertySearchContext.Provider value={{ propertySearchOptions }}>
      {children}
    </PropertySearchContext.Provider>
  )
}
